import React from 'react';
import { usePolywizzContext } from '../context';
import { Option } from '../../../interfaces/Option';
import { FormInput } from '../../../components';
import { DateRangePicker } from 'rsuite';
import ClientAutocomplete from '../../../components/ClientAutocomplete';
import Select from 'react-select';
import { camelCaseToText } from '../../../utils/camelCaseToText';

type DataForFormsConfig = {
    label: string;
    type: string;
    value: any;
    name: string;
    options: any;
    onSelected: any;
    onChange: any;
    onKeyDown: any;
    placeholder: string;
    dataTestId: string;
    onClean?: any;
};

const Filters = () => {
    const { t, filterConfigs } = usePolywizzContext();
    const { dataForForms, handleSelectClientInSearch, handleFreeSearch } = filterConfigs;

    console.log('result ', filterConfigs.dataForForms[3].value.start, filterConfigs.dataForForms[3].value.end);

    return (
        <div className="filters">
            <div className="fixed-size-filter free-search">
                <label>{t('Search')}</label>
                <ClientAutocomplete
                    onAutocompleteSelect={handleSelectClientInSearch}
                    handleFreeSearch={handleFreeSearch}
                    onClear={() => handleSelectClientInSearch('')}
                />
            </div>
            {dataForForms &&
                dataForForms.length > 0 &&
                dataForForms.map((config: DataForFormsConfig) => (
                    <div key={config.name} className="filter">
                        {config.type === 'dateRange' ? (
                            <div className="fixed-size-filter">
                                <label>{t(config.label)}</label>
                                <DateRangePicker
                                    value={config.value.start && config.value.end ? [new Date(config.value.start), new Date(config.value.end)] : null}
                                    onChange={config.onChange}
                                    placeholder={t(config.placeholder)}
                                    onClean={config.onClean}
                                />
                            </div>
                        ) : config.type === 'select' ? (
                            <div className="fixed-size-filter">
                                <label>{t(config.label)}</label>
                                <Select
                                    options={
                                        config.options
                                            ? config.options.map((option: Option) => ({
                                                  label: t(option.label),
                                                  value: option.value,
                                              }))
                                            : []
                                    }
                                    onChange={config.onChange}
                                    value={{ label: camelCaseToText(t(config.value?.label)), value: config.value?.value }}
                                    className="d-flex flex-wrap"
                                    styles={{
                                        menu: (base) => ({
                                            ...base,
                                            width: '100%',
                                        }),
                                        control: (base) => ({
                                            ...base,
                                            width: '100%',
                                        }),
                                    }}
                                />
                            </div>
                        ) : (
                            <FormInput
                                label={t(config.label)}
                                type={config.type}
                                value={config.value}
                                name={config.name}
                                containerClass={'mb-3'}
                                options={
                                    config.options
                                        ? config.options.map((option: Option) => ({
                                              label: t(option.label),
                                              value: option.value,
                                          }))
                                        : []
                                }
                                onSelected={config.onSelected}
                                onChange={config.onChange}
                                onKeyDown={config.onKeyDown}
                                placeholder={config.placeholder}
                                data-test-id={config.dataTestId}
                            />
                        )}
                    </div>
                ))}
        </div>
    );
};

export default Filters;
